export const getPaymentInvoicesState = state => state.paymentInvoices;
